/* ============================================================
   JEWELRY CONFIGURATOR v4 — Aramini
   Solo Summer Twist · Charm 9kt + 18kt · jQuery
   ============================================================ */

(function ($) {
  'use strict';

  /* ─────────────────────────────────────────
     VARIANTI SUMMER TWIST (colore-taglia → shopify variant id)
  ───────────────────────────────────────── */
  var TWIST_VARIANT_MAP = {
    'blu-small':       '58160545661302',
    'blu-big':         '58160545694070',
    'rosso-small':     '58160545726838',
    'rosso-big':       '58160545759606',
    'rosa-small':      '58160545792374',
    'rosa-big':        '58160545825142',
    'verde-small':     '58160545857910',
    'verde-big':       '58160545890678',
    'marrone-small':   '58160545923446',
    'marrone-big':     '58160545956214',
    'beige-small':     '58160545988982',
    'beige-big':       '58160546021750',
    'arancione-small': '58160546054518',
    'arancione-big':   '58160546087286',
    'celeste-small':   '58160546120054',
    'celeste-big':     '58160546152822',
  };

  /* ─────────────────────────────────────────
     CONFIG
  ───────────────────────────────────────── */
  var CONFIG = {

    twist: {
      name: 'SUMMER-TWIST',
      basePrice: { small: 26.00, big: 26.00 },
      sizes: [
        { id: 'small', label: 'Small', sub: '13,5–17,5 cm' },
        { id: 'big',   label: 'Big',   sub: '18–22 cm' },
      ],
      variants: [
        { id: 'blu',       name: 'Blu Navy',       nameEn: 'Navy Blue',     color: '#3A6EA8',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-blu.png?v=1784198704',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-blu.png?v=1784198706' },
        { id: 'rosso',     name: 'Rosso',          nameEn: 'Red',           color: '#C0392B',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-rosso.png?v=1784198708',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-rosso.png?v=1784198710' },
        { id: 'rosa',      name: 'Rosa',           nameEn: 'Pink',          color: '#E8A5B0',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-rosa.png?v=1784198712',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-rosa.png?v=1784198714' },
        { id: 'verde',     name: 'Verde Smeraldo', nameEn: 'Emerald Green', color: '#2D5A3D',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-verde.png?v=1784198716',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-verde.png?v=1784198718' },
        { id: 'marrone',   name: 'Marrone Scuro',  nameEn: 'Dark Brown',    color: '#6B3F2A',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-marrone.png?v=1784198720',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-marrone.png?v=1784198722' },
        { id: 'beige',     name: 'Beige',          nameEn: 'Beige',         color: '#D4B896',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-beige.png?v=1784198724',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-beige.png?v=1784198726' },
        { id: 'arancione', name: 'Arancione',      nameEn: 'Orange',        color: '#E8752A',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-arancione.png?v=1784198728',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-arancione.png?v=1784198730' },
        { id: 'celeste',   name: 'Celeste',        nameEn: 'Light Blue',    color: '#87CEEB',
          img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-circ-celeste.png?v=1784198731',
          flatImg: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/cord-flat-celeste.png?v=1784199626' },
      ],
    },

    charms9kt: [
      { id: 'mystic',     name: 'Mystic Charm',       price: 380, emoji: '✝️',  shopifyVariantId: '58160552542582', variants: [],
        img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-mystic.png?v=1784199630' },
      { id: 'spicy',      name: 'Spicy Luck Charm',   price: 210, emoji: '🌶️', shopifyVariantId: '58160553525622', variants: [],
        img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-spicy.png?v=1784199633' },
      { id: 'ladybug',    name: 'Ladybug Charm',      price: 340, emoji: '🐞',  shopifyVariantId: '58160554246518', variants: [],
        img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-ladybug.png?v=1784199637' },
      { id: 'flyaway',    name: 'Fly Away Charm',     price: 285, emoji: '🦋',  shopifyVariantId: null,
        variants: [
          { id: 'azzurra', name: 'Azzurra', shopifyVariantId: '58160554738038',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-flyaway-azzurra.png?v=1784199651' },
          { id: 'fucsia',  name: 'Fucsia',  shopifyVariantId: '58160554770806',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-flyaway-fucsia.png?v=1784199657' },
          { id: 'rosa',    name: 'Rosa',    shopifyVariantId: '58160554803574',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-flyaway-rosa.png?v=1784199662' },
        ]},
      { id: 'safelove',   name: 'Safe Love Charm',    price: 285, emoji: '🔒',  shopifyVariantId: '58160555950454', variants: [],
        img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-safelove.png?v=1784199643' },
      { id: 'secretkey',  name: 'The Secret Key Charm', price: 210, emoji: '🗝️', shopifyVariantId: '58160555983222', variants: [],
        img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-9kt-secretkey.png?v=1784199648' },
    ],

    charms18kt: [
      { id: 'ride-the-wave', name: 'Ride The Wave', price: 570,
        variants: [
          { id: 'yellow', name: 'Yellow', shopifyVariantId: '57863389348214',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-ride-the-wave-yellow.webp?v=1782492968' },
        ]},
      { id: 'tied-to-you', name: 'Tied To You', price: 590,
        variants: [
          { id: 'white',  name: 'White',  shopifyVariantId: '57863389413750',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-tied-to-you-white.webp?v=1782492969' },
          { id: 'yellow', name: 'Yellow', shopifyVariantId: '57863389446518',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-tied-to-you-yellow.webp?v=1782492971' },
        ]},
      { id: 'tender-bear', name: 'Tender Bear', price: 620,
        variants: [
          { id: 'brown',      name: 'Brown',      shopifyVariantId: '57863388856694',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-tender-bear-brown.webp?v=1782492972' },
          { id: 'light-blue', name: 'Light Blue', shopifyVariantId: '57863388889462',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-tender-bear-light-blue.webp?v=1782492974' },
          { id: 'pearly',     name: 'Pearly',     shopifyVariantId: '57863388922230',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-tender-bear-pearly.webp?v=1782492976' },
        ]},
      { id: 'fortune', name: 'Fortune', price: 810,
        variants: [
          { id: 'yellow', name: 'Yellow', shopifyVariantId: '57870102331766',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-fortune-yellow.webp?v=1782492966' },
          { id: 'white',  name: 'White',  shopifyVariantId: '57870102364534',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-fortune-white.webp?v=1782492964' },
        ]},
      { id: 'bright-future', name: 'Bright Future', price: 925,
        variants: [
          { id: 'white',  name: 'White',  shopifyVariantId: '57863388594550',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-bright-future-white.webp?v=1782492961' },
          { id: 'yellow', name: 'Yellow', shopifyVariantId: '57863388627318',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-bright-future-yellow.webp?v=1782492962' },
        ]},
      { id: 'keep-close', name: 'Keep Close', price: 735,
        variants: [
          { id: 'light-blue', name: 'Light Blue', shopifyVariantId: '57863231701366',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-keep-close-light-blue.webp?v=1782492982' },
          { id: 'red',        name: 'Red',        shopifyVariantId: '57863231734134',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-keep-close-red.webp?v=1782492987' },
          { id: 'pearly',     name: 'Pearly',     shopifyVariantId: '57863231766902',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-keep-close-pearly.webp?v=1782492984' },
          { id: 'pink',       name: 'Pink',       shopifyVariantId: '57863231799670',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-keep-close-pink.webp?v=1782492985' },
          { id: 'beige',      name: 'Beige',      shopifyVariantId: '57863231832438',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-keep-close-beige.webp?v=1782492978' },
          { id: 'fuchsia',    name: 'Fuchsia',    shopifyVariantId: '57863231865206',
            img: 'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/charm-keep-close-fuchsia.webp?v=1782492979' },
        ]},
    ],
  };

  /* ─────────────────────────────────────────
     I18N
  ───────────────────────────────────────── */
  var LANG = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0 ? 'it' : 'en';

  /* ─────────────────────────────────────────
     INDOSSATI (worn) per charm / variante
  ───────────────────────────────────────── */
  var WORN = {
    'mystic': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0479.jpg?v=1784211584',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0510.jpg?v=1784211587',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0563.jpg?v=1784211592',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0617.jpg?v=1784211599'
    ],
    'spicy': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5017.jpg?v=1784211559',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0563.jpg?v=1784211592'
    ],
    'ladybug': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5017.jpg?v=1784211559',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5043.jpg?v=1784211564',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0479.jpg?v=1784211584',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0563.jpg?v=1784211592'
    ],
    'tied-to-you': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0510.jpg?v=1784211587',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0563.jpg?v=1784211592',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0617.jpg?v=1784211599'
    ],
    'fortune': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5017.jpg?v=1784211559',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0563.jpg?v=1784211592',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0617.jpg?v=1784211599'
    ],
    'bright-future': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5017.jpg?v=1784211559',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0563.jpg?v=1784211592',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0581.jpg?v=1784211597'
    ],
    'tender-bear:brown': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0368.jpg?v=1784211572',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0388.jpg?v=1784211574',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0424.jpg?v=1784211580'
    ],
    'tender-bear:light-blue': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5048.jpg?v=1784211567',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5053.jpg?v=1784211570',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0517.jpg?v=1784211589'
    ],
    'keep-close:red': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-4955.jpg?v=1784211556',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5036.jpg?v=1784211562',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5048.jpg?v=1784211567',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5053.jpg?v=1784211570',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0510.jpg?v=1784211587'
    ],
    'keep-close:pearly': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5017.jpg?v=1784211559',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0388.jpg?v=1784211574',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0617.jpg?v=1784211599'
    ],
    'keep-close:pink': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-4955.jpg?v=1784211556',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0388.jpg?v=1784211574',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0422.jpg?v=1784211578'
    ],
    'keep-close:light-blue': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5017.jpg?v=1784211559',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0581.jpg?v=1784211597'
    ],
    'keep-close:beige': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0388.jpg?v=1784211574',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0517.jpg?v=1784211589'
    ],
    'keep-close:fuchsia': [
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-5043.jpg?v=1784211564',
      'https://cdn.shopify.com/s/files/1/0589/9219/7679/t/24/assets/worn-adm0422.jpg?v=1784211578'
    ]
  };
  function getWornPhotos() {
    var ch = getCharm(); if (!ch) return [];
    var cv = getCharmVariant();
    if (cv && WORN[ch.id + ':' + cv.id]) return WORN[ch.id + ':' + cv.id];
    return WORN[ch.id] || [];
  }

  var T = {
    it: {
      startingFrom: 'A partire da',
      rowCordColor: 'Colore cordino',
      rowSize:      'Misura',
      rowBasePrice: 'Prezzo base',
      rowCharm:     'Charm',
      rowType:      'Tipologia',
      rowCharmPrice:'Prezzo charm',
      gold9:        'Oro 9kt · Diamanti naturali',
      gold18:       'Oro 18kt · Diamanti naturali',
      none:         'Nessuno',
      total:        'totale',
      charm9label:  'Charm 9kt · Diamanti naturali',
      charm18label: 'Charm 18kt · Diamanti naturali',
      adding:       'Aggiunta in corso…',
      added:        '✓ Aggiunto al carrello!',
      addedBtn:     'Aggiunto ✓',
      errVariant:   'Errore: variante non trovata.',
      // chiavi proprietà carrello (IT)
      propColor:    'Colore cordino',
      propSize:     'Misura',
      propCharm:    'Charm',
      propType:     'Tipologia charm',
      propTotal:    'Prezzo totale',
    },
    en: {
      startingFrom: 'Starting from',
      rowCordColor: 'Cord colour',
      rowSize:      'Size',
      rowBasePrice: 'Base price',
      rowCharm:     'Charm',
      rowType:      'Type',
      rowCharmPrice:'Charm price',
      gold9:        '9kt Gold · Natural diamonds',
      gold18:       '18kt Gold · Natural diamonds',
      none:         'None',
      total:        'total',
      charm9label:  'Charm 9kt · Natural diamonds',
      charm18label: 'Charm 18kt · Natural diamonds',
      adding:       'Adding…',
      added:        '✓ Added to cart!',
      addedBtn:     'Added ✓',
      errVariant:   'Error: variant not found.',
      // cart property keys (EN)
      propColor:    'Cord colour',
      propSize:     'Size',
      propCharm:    'Charm',
      propType:     'Charm type',
      propTotal:    'Total price',
    },
  };
  function t(key) { return (T[LANG] && T[LANG][key]) || T.en[key] || key; }
  // nome colore secondo la lingua
  function cname(v) { return (LANG === 'en' && v.nameEn) ? v.nameEn : v.name; }

  /* ─────────────────────────────────────────
     STATE
  ───────────────────────────────────────── */
  var S = {
    colorId:        null,
    sizeId:         null,
    charmId:        null,
    charmVariantId: null,
  };

  function getVariant() {
    return CONFIG.twist.variants.find(function (v) { return v.id === S.colorId; });
  }
  function getSize() {
    return CONFIG.twist.sizes.find(function (s) { return s.id === S.sizeId; });
  }
  function getAllCharms() {
    return CONFIG.charms9kt.concat(CONFIG.charms18kt);
  }
  function getCharm() {
    return getAllCharms().find(function (c) { return c.id === S.charmId; });
  }
  function getCharmVariant() {
    var ch = getCharm();
    if (!ch || !ch.variants.length) return null;
    return ch.variants.find(function (v) { return v.id === S.charmVariantId; });
  }
  function getCharmCategory(id) {
    if (CONFIG.charms9kt.find(function(c){ return c.id === id; })) return '9kt';
    return '18kt';
  }
  function isReady() { return !!(S.colorId && S.sizeId); }
  function fmt(n)    { return '€' + n.toFixed(2).replace('.', ','); }

  function basePrice() {
    return S.sizeId === 'big' ? CONFIG.twist.basePrice.big : CONFIG.twist.basePrice.small;
  }
  function charmPrice() {
    var ch = getCharm(); return ch ? ch.price : 0;
  }
  function totalPrice() { return basePrice() + charmPrice(); }

  function cheapestCharmId() {
    var all = getAllCharms();
    var min = all.reduce(function (a, b) { return a.price <= b.price ? a : b; });
    return min.id;
  }

  /* ─────────────────────────────────────────
     SCROLL
  ───────────────────────────────────────── */
  function scrollTo($el) {
    var top = $el.offset().top - 80;
    if (typeof scroll !== 'undefined' && scroll.scrollTo) {
      scroll.scrollTo($el[0], { offset: -80 });
    } else {
      $('html, body').animate({ scrollTop: top }, 500);
    }
  }

  /* ─────────────────────────────────────────
     CTA STATE
  ───────────────────────────────────────── */
  function updateCta() {
    var $btn  = $('#jc-cta-1');
    var $hint = $('#jc-cta-hint');
    if (isReady()) {
      $btn.addClass('enabled').attr('aria-disabled', 'false');
      $hint.addClass('ready').text($hint.data('ready'));
    } else {
      $btn.removeClass('enabled').attr('aria-disabled', 'true');
      $hint.removeClass('ready').text($hint.data('pending'));
    }
  }

  function updateStartingPrice() {
    var minCharm = getAllCharms().reduce(function (a, b) { return a.price <= b.price ? a : b; });
    var minPrice = CONFIG.twist.basePrice.small + minCharm.price;
    $('#jc-starting-price').text(t('startingFrom') + ' ' + fmt(minPrice));
  }

  /* ─────────────────────────────────────────
     REVEAL PANEL
  ───────────────────────────────────────── */
  function reveal($panel) {
    $panel.addClass('open');
    setTimeout(function () { scrollTo($panel); }, 120);
  }

  /* ─────────────────────────────────────────
     PREVIEW IMMAGINE (step 1 + step 2)
  ───────────────────────────────────────── */
  function updatePreviewImage(containerId) {
    var variant  = getVariant();
    var $ph      = $('#' + containerId + '-base');
    var $img     = $('#' + containerId + '-flat-img');

    if (variant && variant.flatImg) {
      $ph.hide();
      if (!$img.length) {
        $('<img>').attr({ id: containerId + '-flat-img', src: variant.flatImg, alt: variant.name })
          .insertBefore($ph);
      } else {
        $img.attr('src', variant.flatImg).show();
      }
    } else if (variant) {
      if ($img.length) $img.hide();
      $ph.css({ background: variant.color + '28', borderColor: variant.color + '66' }).show();
    }
  }

  /* ─────────────────────────────────────────
     STEP 2 — charm builder
  ───────────────────────────────────────── */
  function renderCharmStep() {
    updatePreviewImage('jc-preview');

    // pre-seleziona charm più economico se nessuno scelto
    if (!S.charmId) {
      S.charmId = cheapestCharmId();
      var ch = getCharm();
      if (ch && ch.variants.length) {
        S.charmVariantId = ch.variants[0].id;
      }
    }

    renderCharmGrid();
    updateCharmOverlay();
    updateStep2Price();
  }

  function renderCharmGrid() {
    function charmCard(ch, category) {
      var priceTag = ch.price > 0
        ? '<span class="jc-charm-price">' + fmt(ch.price) + '</span>'
        : '<span class="jc-charm-price jc-price-tbd">TBD</span>';

      if (ch.variants.length > 0) {
        return ch.variants.map(function (v) {
          var isSelected = S.charmId === ch.id && S.charmVariantId === v.id;
          var sel = isSelected ? ' selected' : '';
          var icon = v.img
            ? '<img src="' + v.img + '" alt="' + ch.name + ' ' + v.name + '">'
            : (ch.emoji ? '<span class="jc-charm-emoji">' + ch.emoji + '</span>' : '');
          return '<div class="jc-charm-card' + sel + '" data-charm="' + ch.id + '" data-charm-variant="' + v.id + '" role="button" tabindex="0">' +
                   '<div class="jc-charm-circle">' + icon + '</div>' +
                   '<span class="jc-charm-name">' + ch.name + '</span>' +
                   priceTag +
                 '</div>';
        }).join('');
      } else {
        var isSelected = S.charmId === ch.id;
        var sel = isSelected ? ' selected' : '';
        var icon = ch.img
          ? '<img src="' + ch.img + '" alt="' + ch.name + '">'
          : (ch.emoji ? '<span class="jc-charm-emoji">' + ch.emoji + '</span>' : '');
        return '<div class="jc-charm-card' + sel + '" data-charm="' + ch.id + '" data-charm-variant="" role="button" tabindex="0">' +
                 '<div class="jc-charm-circle">' + icon + '</div>' +
                 '<span class="jc-charm-name">' + ch.name + '</span>' +
                 priceTag +
               '</div>';
      }
    }

    var html9  = CONFIG.charms9kt.map(function(c)  { return charmCard(c, '9kt');  }).join('');
    var html18 = CONFIG.charms18kt.map(function(c) { return charmCard(c, '18kt'); }).join('');

    $('#jc-charm-grid').html(
      '<p class="jc-charm-category-label">' + t('charm9label') + '</p>' +
      '<div class="jc-charm-row jc-charm-row-9">' + html9 + '</div>' +
      '<div class="jc-charm-divider"></div>' +
      '<p class="jc-charm-category-label">' + t('charm18label') + '</p>' +
      '<div class="jc-charm-row jc-charm-row-18">' + html18 + '</div>'
    );
    bindCharmEvents();
  }

  function bindCharmEvents() {
    $('#jc-charm-grid').off('click').on('click', '.jc-charm-card', function () {
      var id  = $(this).data('charm');
      var vid = $(this).data('charm-variant') || null;

      if (S.charmId === id && S.charmVariantId === (vid || null)) {
        S.charmId = null; S.charmVariantId = null;
      } else {
        S.charmId = id; S.charmVariantId = vid || null;
      }
      $('#jc-charm-grid .jc-charm-card').removeClass('selected');
      if (S.charmId) $(this).addClass('selected');
      updateCharmOverlay();
      updateStep2Price();
      // scroll all'anteprima
      scrollTo($('.jc-preview-stage'));
    });
  }

  function updateCharmOverlay() {
    var charm    = getCharm();
    var cv       = getCharmVariant();
    var $overlay = $('#jc-charm-overlay');
    var $inner   = $('#jc-charm-overlay-inner');
    var $hint    = $('#jc-remove-hint');
    if (charm) {
      var imgSrc = cv ? cv.img : (charm.img || null);
      $inner.html(imgSrc
        ? '<img src="' + imgSrc + '" alt="' + charm.name + '">'
        : '<div class="charm-ph">' + (charm.emoji || '✦') + '</div>');
      $overlay.addClass('visible');
      $hint.addClass('show');
    } else {
      $overlay.removeClass('visible');
      $hint.removeClass('show');
    }
  }

  function updateStep2Price() {
    var charm = getCharm();
    var total = basePrice() + (charm ? charm.price : 0);
    var charmName = charm ? charm.name.toUpperCase() : null;
    var charmPart = charm
      ? (charm.price > 0 ? ' + ' + charmName + ' = ' + fmt(total) : ' + ' + charmName + ' = TBD')
      : '';
    $('#jc-step2-price').html('SUMMER-TWIST' + charmPart);
  }

  /* ─────────────────────────────────────────
     STEP 3 — riepilogo
  ───────────────────────────────────────── */
  function renderSummary() {
    var variant = getVariant();
    var size    = getSize();
    var charm   = getCharm();
    var cv      = getCharmVariant();

    // immagine base
    updatePreviewImage('jc-sum');

    // charm overlay summary
    var $sc = $('#jc-sum-charm');
    var cvImg = cv ? cv.img : (charm ? charm.img : null);
    $sc.html(charm
      ? (cvImg
          ? '<img src="' + cvImg + '" alt="' + charm.name + '" style="width:56px;height:56px;object-fit:contain;">'
          : '<div class="charm-ph">' + (charm.emoji || '✦') + '</div>')
      : '');

    // righe riepilogo
    $('#jc-sum-name').text('SUMMER-TWIST' + (variant ? ' · ' + cname(variant) : '') + (size ? ' · ' + size.label : ''));

    var rows = [
      { k: t('rowCordColor'), v: variant ? cname(variant) : '—' },
      { k: t('rowSize'),      v: size ? size.label + ' (' + size.sub + ')' : '—' },
      { k: t('rowBasePrice'), v: fmt(basePrice()) },
    ];
    if (charm) {
      rows.push({ k: t('rowCharm'),      v: charm.name + (cv ? ' · ' + cv.name : '') });
      rows.push({ k: t('rowType'),       v: getCharmCategory(charm.id) === '9kt' ? t('gold9') : t('gold18') });
      rows.push({ k: t('rowCharmPrice'), v: charm.price > 0 ? fmt(charm.price) : 'TBD' });
    } else {
      rows.push({ k: t('rowCharm'), v: t('none') });
    }

    $('#jc-sum-rows').html(rows.map(function (r) {
      return '<div class="jc-config-row"><span class="k">' + r.k + '</span><span class="v">' + r.v + '</span></div>';
    }).join(''));

    $('#jc-sum-total').html(fmt(totalPrice()) + ' <small>' + t('total') + '</small>');

    // galleria riepilogo: creazione + indossati
    renderSumGallery();
  }

  /* ─────────────────────────────────────────
     STEP 3 — galleria (visualizzatore + miniature + lightbox)
  ───────────────────────────────────────── */
  function renderSumGallery() {
    var worn = getWornPhotos();
    var v = getVariant();
    var compImg = (v && v.flatImg) ? v.flatImg : '';

    var html = '<div class="jc-thumb jc-thumb-config" data-media="config" title="' +
                 (LANG === 'it' ? 'La tua creazione' : 'Your creation') + '">' +
                 (compImg ? '<img src="' + compImg + '" alt="">' : '') +
               '</div>';
    worn.forEach(function (u, i) {
      html += '<div class="jc-thumb" data-media="' + i + '"><img src="' + u + '" alt=""></div>';
    });
    $('#jc-sum-thumbs').html(html).toggle(worn.length > 0);

    showSumMedia('config');
  }

  function showSumMedia(which) {
    var $comp  = $('#jc-sum-composite');
    var $media = $('#jc-sum-media');
    if (which === 'config') {
      $media.hide().attr('src', '');
      $comp.show();
    } else {
      var url = getWornPhotos()[parseInt(which, 10)];
      if (url) { $comp.hide(); $media.attr('src', url).show(); }
    }
    $('#jc-sum-thumbs .jc-thumb').removeClass('selected');
    $('#jc-sum-thumbs .jc-thumb[data-media="' + which + '"]').addClass('selected');
  }

  function openLightbox(src) {
    $('#jc-lightbox img').attr('src', src);
    $('#jc-lightbox').addClass('open');
  }

  /* ─────────────────────────────────────────
     ADD TO CART
  ───────────────────────────────────────── */
  function addToCart() {
    var variant = getVariant();
    var size    = getSize();
    var charm   = getCharm();
    var cv      = getCharmVariant();
    var $btn    = $('#jc-add-to-cart');
    var $msg    = $('#jc-cart-feedback');

    var shopifyVid = TWIST_VARIANT_MAP[S.colorId + '-' + S.sizeId];
    if (!shopifyVid) { $msg.text(t('errVariant')).addClass('show'); return; }

    $btn.prop('disabled', true).text(t('adding'));

    // variante Shopify del charm selezionato (verrà aggiunto come riga separata)
    var charmVid = charm ? (cv ? cv.shopifyVariantId : charm.shopifyVariantId) : null;

    // proprietà nascosta per collegare cordino + charm nello stesso ordine
    var groupId = 'ST-' + Date.now();
    var lineItems = [{ id: shopifyVid, quantity: 1, properties: { '_config': groupId } }];
    if (charmVid) {
      lineItems.push({ id: charmVid, quantity: 1, properties: { '_config': groupId } });
    }

    // Dawn: aggiorna il cart-drawer via Section Rendering API
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = (cartDrawer && cartDrawer.getSectionsToRender)
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.section; })
      : [];

    var addBody = { items: lineItems };
    if (sections.length) {
      addBody.sections = sections;
      addBody.sections_url = window.location.pathname;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(addBody),
    })
    .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
    .then(function (res) {
      if (!res.ok) {
        // errore (es. esaurito): mostra messaggio Shopify
        $msg.text((res.data && res.data.description) || t('errVariant')).addClass('show');
        $btn.prop('disabled', false).text($btn.data('label'));
        return;
      }
      $msg.text(t('added')).addClass('show');
      $btn.text(t('addedBtn'));

      // aggiorna e apri il cart-drawer del tema (Dawn)
      var opened = false;
      try {
        if (cartDrawer && res.data.sections && cartDrawer.renderContents) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(res.data);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
          opened = true;
        }
      } catch (e) { opened = false; }

      // notifica generica per altri componenti eventualmente in ascolto
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      if (!opened) {
        // il drawer non si è aggiornato: vai alla pagina carrello (mostra comunque l'articolo aggiunto)
        window.location = root + 'cart';
        return;
      }

      setTimeout(function () {
        $btn.prop('disabled', false).text($btn.data('label'));
      }, 3000);
    })
    .catch(function () {
      // errore di rete: l'articolo potrebbe non essere stato aggiunto → porta al carrello
      window.location = root + 'cart';
    });
  }

  /* ─────────────────────────────────────────
     INIT
  ───────────────────────────────────────── */
  function init() {

    // ── Etichette colore secondo lingua (unica fonte: CONFIG) ──
    $('.jc-circle-wrap').each(function () {
      var $wrap = $(this);
      var vid = $wrap.data('variant');
      var v = CONFIG.twist.variants.find(function (x) { return x.id === vid; });
      if (v) $wrap.find('.jc-circle-label').text(cname(v));
    });

    // ── Selezione cerchio colore ──
    $(document).on('click', '.jc-circle-wrap', function () {
      var $wrap = $(this);
      var vid   = $wrap.data('variant');

      S.colorId = vid;
      S.sizeId  = null;

      $('.jc-circle-wrap').removeClass('selected');
      $wrap.addClass('selected');
      $('.jc-size-btn').removeClass('selected');

      // mostra misure
      $('#jc-sizes-twist').addClass('visible');

      // aggiorna anteprima inline (step 1)
      updateInlinePreview();
      updateStartingPrice();
      updateCta();
    });

    // ── Selezione misura ──
    $(document).on('click', '.jc-size-btn', function () {
      var $btn = $(this);
      S.sizeId = $btn.data('size');
      $('.jc-size-btn').removeClass('selected');
      $btn.addClass('selected');
      updateCta();
    });

    // ── CTA Step 1 → reveal Step 2 ──
    $('#jc-cta-1').on('click', function () {
      if (!isReady()) return;
      renderCharmStep();
      reveal($('#jc-reveal-2'));
    });

    // ── CTA Step 2 → reveal Step 3 ──
    $('#jc-cta-2').on('click', function () {
      renderSummary();
      reveal($('#jc-reveal-3'));
    });

    // ── Indietro ──
    $('#jc-back-1').on('click', function () {
      $('#jc-reveal-2, #jc-reveal-3').removeClass('open');
      S.charmId = null; S.charmVariantId = null;
      scrollTo($('.jc-section'));
    });
    $('#jc-back-2').on('click', function () {
      $('#jc-reveal-3').removeClass('open');
      scrollTo($('#jc-reveal-2'));
    });

    // ── Add to cart ──
    $('#jc-add-to-cart').on('click', addToCart);

    // ── Galleria riepilogo: miniature + lightbox ──
    $(document).on('click', '#jc-sum-thumbs .jc-thumb', function () {
      showSumMedia(String($(this).data('media')));
    });
    $(document).on('click', '#jc-sum-media', function () {
      var src = $(this).attr('src');
      if (src) openLightbox(src);
    });
    $(document).on('click', '#jc-lightbox', function () { $(this).removeClass('open'); });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') $('#jc-lightbox').removeClass('open');
    });

    // ── Accessibilità ──
    $(document).on('keydown', '.jc-circle-wrap, .jc-size-btn, .jc-charm-card', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $(this).trigger('click'); }
    });

    updateCta();
  }

  // anteprima inline nello step 1 (ingrandisce il cerchio selezionato)
  function updateInlinePreview() {
    var v = getVariant();
    var $preview = $('#jc-color-preview');
    if (!v) { $preview.hide(); return; }

    if (v.img) {
      $preview.find('img').attr('src', v.img);
      $preview.show();
    } else {
      $preview.find('img').attr('src', '');
      $preview.css('background', v.color + '22').show();
    }
  }

  $(document).ready(function () {
    if ($('.jc-section').length) init();
  });

})(jQuery);
